import React from "react";
import { AbsoluteFill } from "remotion";

/**
 * The ONE canonical holes-distress layer for the devotional ("Trimbakeshwar
 * holes treatment") overlay kit.
 *
 * ⛔ WHY THIS EXISTS — read before hand-rolling a mask again.
 *
 * A CSS mask CLIPS TO ITS OWN ELEMENT'S BORDER BOX. Every per-production file
 * used to declare its own `holesStyle` object and it was only a copy-paste away
 * from being spread into the per-word <span>. When that happens you get TWO
 * symptoms that look unrelated but are one bug:
 *
 *   1. A dark rectangle around EVERY WORD — the mask tile restarts at each word
 *      and its edge cuts a hard boundary through that word's textShadow.
 *   2. Devanagari MATRAS SLICED OFF (ि ी े ै ो ौ ृ ु ं ँ) — matra ink renders
 *      ABOVE and BELOW the em box, so a tight lineHeight leaves it outside the
 *      span box and the mask zeroes its alpha.
 *
 * Both are impossible here, because the mask lives on ONE frame-sized layer:
 * the mask box IS the whole frame, so nothing can be clipped by it.
 *
 * Shipped broken into three finished 4K renders (teej dcb24bcc, onam 3781a854,
 * raksha_bandhan d4333779) on 2026-08-02/03 before this was factored out.
 *
 * USAGE — wrap ONLY the phrase Sequences. UI (Teaser / WatchTip / the
 * DevaKathaHypeCta phone / the logo) must stay OUTSIDE, unmasked:
 *
 *   <AbsoluteFill style={{ backgroundColor: "transparent" }}>
 *     <HolesLayer holes={HOLES_DATA_URI}>
 *       {PHRASES.map((p, i) => (
 *         <Sequence key={i} from={...} durationInFrames={...}>
 *           <PhraseCard p={p} />
 *         </Sequence>
 *       ))}
 *     </HolesLayer>
 *     <Sequence ...><Teaser /></Sequence>
 *   </AbsoluteFill>
 */
export const HolesLayer: React.FC<{
  holes: string;
  /** Frame size. Devotional comps are 1280x704; pass explicitly if yours differs. */
  width?: number;
  height?: number;
  children: React.ReactNode;
}> = ({ holes, width = 1280, height = 704, children }) => (
  <AbsoluteFill
    style={{
      backgroundColor: "transparent",
      WebkitMaskImage: `url(${holes})`,
      maskImage: `url(${holes})`,
      // no-repeat at FRAME size. The holes plate is a single full-frame distress
      // texture, NOT a tile — `repeat` with a tile size is always wrong here.
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      WebkitMaskSize: `${width}px ${height}px`,
      maskSize: `${width}px ${height}px`,
      WebkitMaskPosition: "0 0",
      maskPosition: "0 0",
    }}
  >
    {children}
  </AbsoluteFill>
);

export default HolesLayer;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
